const TABS = [
  { id: 'forms', label: 'SS forms' },
  { id: 'council', label: 'Council / Agency' },
];

/**
 * Sub-tabs under Building → Paperwork (forms · issued · council).
 */
export default function BuildingPaperworkTabs({ active, onChange }) {
  return (
    <div className="mb-4 flex flex-wrap gap-1 border-b border-slate-200">
      {TABS.map((t) => {
        const selected = active === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            className={`px-3.5 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
              selected
                ? 'border-primary-600 text-primary-800'
                : 'border-transparent text-slate-600 hover:text-slate-900 hover:border-slate-300'
            }`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

export const PAPERWORK_TAB_IDS = TABS.map((t) => t.id);

export function normalizePaperworkTab(raw) {
  const t = String(raw || '').toLowerCase();
  if (t === 'council' || t === 'agency' || t === 'pack') return 'council';
  return 'forms';
}
